/* PlantSwitch tech layer: text decode, datasheet rules, collection count. Runs after GSAP; off for reduced motion. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GLYPHS = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%<>/+=';
  function scramble(el, dur) {
    var final = el.textContent, len = final.length, start = null;
    el.setAttribute('aria-label', final);
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur), out = '';
      for (var i = 0; i < len; i++) {
        var ch = final[i];
        if (ch === ' ' || i < Math.floor(p * len)) out += ch;
        else out += GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (p < 1) requestAnimationFrame(frame); else { el.textContent = final; el.removeAttribute('aria-label'); }
    }
    requestAnimationFrame(frame);
  }
  function init() {
    if (reduce || !window.gsap || !window.ScrollTrigger) return;
    var g = window.gsap;
    /* every mono eyebrow and datasheet value decodes once, when it scrolls into view */
    [].forEach.call(document.querySelectorAll('[data-scramble], .ps-sec .ps-tag'), function (el) {
      if (el.dataset.scrambled) return; el.dataset.scrambled = '1';
      ScrollTrigger.create({ trigger: el, start: 'top 90%', once: true, onEnter: function () { scramble(el, 700 + el.textContent.length * 18); } });
    });
    /* datasheet rows: rule draws across, then the row rises in */
    [].forEach.call(document.querySelectorAll('[data-spec-row]'), function (row) {
      var rule = row.querySelector('.ps-spec__rule');
      g.set(row, { opacity: 0, y: 24 }); if (rule) g.set(rule, { scaleX: 0 });
      ScrollTrigger.create({ trigger: row, start: 'top 88%', once: true, onEnter: function () {
        g.to(row, { opacity: 1, y: 0, duration: .9, ease: 'expo.out' });
        if (rule) g.to(rule, { scaleX: 1, duration: 1.2, ease: 'expo.inOut' });
      } });
    });
    /* collection header: product count ticks up */
    [].forEach.call(document.querySelectorAll('[data-count-to]'), function (el) {
      var n = +el.getAttribute('data-count-to'), o = { v: 0 };
      g.to(o, { v: n, duration: 1.4, ease: 'expo.out', onUpdate: function () { el.textContent = String(Math.round(o.v)).padStart(2, '0'); } });
    });
  }
  document.readyState !== 'loading' ? init() : document.addEventListener('DOMContentLoaded', init);
})();
/* shop rows: the first tile lines up with the page column (and the row heading) at every screen width */
(function () {
  function align() {
    [].forEach.call(document.querySelectorAll('[data-ps-row]'), function (row) {
      var head = row.querySelector('.ps-cg__head'), rail = row.querySelector('[data-ps-rail]'); if (!head || !rail) return;
      var left = Math.round(head.getBoundingClientRect().left + parseFloat(getComputedStyle(head).paddingLeft || 0));
      rail.style.paddingLeft = left + 'px'; rail.style.paddingRight = left + 'px'; rail.style.scrollPaddingInline = left + 'px';
    });
  }
  document.readyState !== 'loading' ? align() : document.addEventListener('DOMContentLoaded', align);
  addEventListener('resize', align, { passive: true });
})();
/* cursor spotlight on product cards (mouse only) */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.addEventListener('pointermove', function (e) {
    var c = e.target.closest && e.target.closest('product-card'); if (!c) return;
    var r = c.getBoundingClientRect();
    c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });
})();
